module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    class: [_vm.$route.name !== 'landing' ? 'not-landing' : ''],
    attrs: {
      "id": "navse",
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "div-container container"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "columns navbar-full is-gapless is-mobile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column column-link is-hidden-touch"
  }, [_c('div', {
    staticClass: "columns is-gapless",
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column has-text-right"
  }, _vm._l((_vm.navSocial), function(navItem) {
    return _c('a', {
      staticClass: "fa",
      attrs: {
        "href": navItem.path,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa",
      class: ['fa-' + navItem.fa]
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless",
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column has-text-right"
  }, _vm._l((_vm.navMain), function(navItem) {
    return _c('a', {
      class: {
        'nav-item-link': true,
        active: _vm.$route.name === navItem.name
      },
      attrs: {
        "href": [navItem.section ? '/?anchor=' + navItem.section : navItem.path]
      },
      on: {
        "click": function($event) {
          [navItem.section ? _vm.onScrollTo($event, 'landing', navItem.section) : '']
        }
      }
    }, [_vm._v("\n                  " + _vm._s(navItem.title) + "\n                ")])
  }), 0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "column navbar-menu",
    attrs: {
      "data-aos": "zoom-in",
      "data-aos-once": "true"
    },
    on: {
      "click": function($event) {
        return _vm.onToggle()
      }
    }
  }, [_c('div', {
    staticClass: "control-menu",
    class: {
      active: _vm.showNav
    }
  }, [_c('span')])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column navbar-brand is-narrow",
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/logo-main.svg"),
      "width": "360"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless",
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column has-text-right link-ticket-wrapper"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/bg_ribbon.svg"),
      "width": "200"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "href": "/tickets"
    }
  }, [_vm._v("\n                      Purchase Tickets\n                    ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05df63c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarFull.vue
// module id = 896
// module chunks = 1